import intl from "react-intl-universal";
import { TbArrowDown, TbArrowUp, TbClockHour4, TbCoin, TbCurrencyDollar } from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { EMPTY_BAAS_STABLES_FILTERS } from "../baasStablesFilters";

const QUICK_FILTERS = [
  {
    id: "usdc",
    labelKey: "baas.stables.quickActions.usdc",
    icon: TbCurrencyDollar,
    filters: {
      ...EMPTY_BAAS_STABLES_FILTERS,
      assets: ["USDC"],
    },
  },
  {
    id: "usdt",
    labelKey: "baas.stables.quickActions.usdt",
    icon: TbCoin,
    filters: {
      ...EMPTY_BAAS_STABLES_FILTERS,
      assets: ["USDT"],
    },
  },
  {
    id: "buy",
    labelKey: "baas.stables.quickActions.buy",
    icon: TbArrowDown,
    filters: {
      ...EMPTY_BAAS_STABLES_FILTERS,
      operations: ["buy"],
    },
  },
  {
    id: "sell",
    labelKey: "baas.stables.quickActions.sell",
    icon: TbArrowUp,
    filters: {
      ...EMPTY_BAAS_STABLES_FILTERS,
      operations: ["sell"],
    },
  },
  {
    id: "pending",
    labelKey: "baas.stables.quickActions.pending",
    icon: TbClockHour4,
    filters: {
      ...EMPTY_BAAS_STABLES_FILTERS,
      statuses: ["pending"],
    },
  },
];

const isPresetActive = (filters, preset) => {
  if (preset.id === "usdc") {
    return filters.assets?.length === 1 && filters.assets[0] === "USDC";
  }
  if (preset.id === "usdt") {
    return filters.assets?.length === 1 && filters.assets[0] === "USDT";
  }
  if (preset.id === "buy") {
    return filters.operations?.length === 1 && filters.operations[0] === "buy";
  }
  if (preset.id === "sell") {
    return filters.operations?.length === 1 && filters.operations[0] === "sell";
  }
  if (preset.id === "pending") {
    return filters.statuses?.length === 1 && filters.statuses[0] === "pending";
  }
  return false;
};

export const BaasStablesQuickActions = ({ filters, onFiltersChange }) => (
  <section className="min-w-0 w-full">
    <p className="dashboard-section-label mb-3">
      {intl.get("baas.stables.quickActionsSection")}
    </p>
    <div className="shortcut-scroll-row">
      {QUICK_FILTERS.map((preset) => (
        <ShortcutCard
          key={preset.id}
          icon={preset.icon}
          label={intl.get(preset.labelKey)}
          active={isPresetActive(filters, preset)}
          onClick={() =>
            onFiltersChange(
              isPresetActive(filters, preset) ? EMPTY_BAAS_STABLES_FILTERS : preset.filters,
            )
          }
        />
      ))}
    </div>
  </section>
);
